import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function localidade(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@localidade/FIND_LOCALIDADE':
      case '@localidade/UPDATE_LOCALIDADE':
      case '@localidade/DELETE_LOCALIDADE':
      case '@localidade/STORE_LOCALIDADE':
      case '@localidade/LOCALIDADES_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@localidade/SUCCESS_REMOVE':
      case '@localidade/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@localidade/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.localidades;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@localidade/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.localidade;
        break;
      }

      case '@localidade/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
